import { EventEmitter, Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { Rol } from '../models/rol';
import { Store } from '../models/store';
import { Subsidiary } from '../models/subsidiary';
import { User } from '../models/user';
import { LocalService } from '../util/local.service';
import { LocalstorageService } from '../util/local.storage.service';

export enum Roles {
  ADMIN = 'ADM',
  MANAGER = 'GER',
  COLABORATOR = 'COL',
  COMERCIAL = 'comercial',
  ECOMMERCE = 'ECO'
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  authenticationState = new BehaviorSubject(false);
  exitSubsidiary: EventEmitter<boolean> = new EventEmitter<boolean>()

  roles: Rol[] = []
  store: Store | undefined;
  subsidiary: Subsidiary | undefined;

  constructor(private _local: LocalService, private localStorage: LocalstorageService ) {
    this.authenticationState.next(false);
  }

  private tipoUsuarioARol: { [key: string]: string } = {
  'Comercial': Roles.MANAGER,
  'Administrador': Roles.ADMIN,
  'E-Commerce': Roles.ECOMMERCE
};

  login(token: string, access_token: string, client_id: string, user: User, roles: Rol[], identity_token: string, firebase_token: string, rol: string) {
    this._local.setLocal('token', token)
    this._local.setLocal('access_token', access_token)
    this._local.setLocal('identity_token', identity_token)
    this._local.setLocal('firebase_token', firebase_token)
    this._local.setLocal('client_id', client_id)
    this._local.setLocal('user', user)
    this._local.setLocal('roles', roles)
    this._local.setLocal('rol', rol)
    this.authenticationState.next(true);
  }

  logout() {
    this._local.cleanLocal('token')
    this._local.cleanLocal('access_token')
    this._local.cleanLocal('identity_token')
    this._local.cleanLocal('firebase_token')
    this._local.cleanLocal('client_id')
    this._local.cleanLocal('user')
    this._local.cleanLocal('roles')
    this._local.cleanLocal('rol')
    this._local.cleanLocal('data')
    this.authenticationState.next(false);
  }

  setData(token: string) {
    this._local.setLocal('data', token)
  }

  getData(): string {
    return this._local.getLocal('data') ? this._local.getLocal('data') : ''
  }

  checkToken() {
    /* istanbul ignore next */
    if (this._local.getLocal('token')) {
      this.authenticationState.next(true);
    } else {
      this.authenticationState.next(false);
    }
  }

  getToken(): string {
    /* istanbul ignore next */
    if (this._local.getLocal('token')) {
      return 'Bearer ' + this._local.getLocal('token')
    } else {
      /* istanbul ignore next */
      return ''
    }
  }

  getAccessToken(): string {
    return this._local.getLocal('access_token') ? this._local.getLocal('access_token') : ''
  }

  getHeader(): any {
    return {
      identity_token: this._local.getLocal('identity_token') ? this._local.getLocal('identity_token') : '',
      user_id: this._local.getLocal('user') ? this._local.getLocal('user')['userId'] : '',
      firebase_token: this._local.getLocal('firebase_token') ? this._local.getLocal('firebase_token') : '',
    }
  }

  getClientId(): string {
    return this._local.getLocal('client_id') ? this._local.getLocal('client_id') : ''
  }

  isAuthenticated(): boolean {
    return this.authenticationState.value;
  }

  cleanLocal(id: string) {
    this.localStorage.removeItem(id);
  }

  isAdmin(): boolean {
    return this._local.getLocal('rol') == Roles.ADMIN
  }
  isManager(): boolean {
    return this._local.getLocal('rol') == Roles.MANAGER
  }
  isColaborator(): boolean {
    return this._local.getLocal('rol') == Roles.COLABORATOR
  }

  isComercial (): boolean {
    return this._local.getLocal('rol') == Roles.COMERCIAL
  }

  isEco (): boolean {
    return this._local.getLocal('rol') == Roles.ECOMMERCE
  }

  getRol(rolName: string): Rol {
    this.roles = this._local.getLocal('roles')
    let filtered = this.roles.filter(el => {
      return el.roleName == rolName
    })
    // @ts-ignore
    return filtered.length > 0 ? filtered[0] : null
  }

  getAdmin(): Rol {
    return this.getRol(Roles.ADMIN)
  }
  getManager(): Rol {
    return this.getRol(Roles.MANAGER)
  }
  getColaborator(): Rol {
    return this.getRol(Roles.COLABORATOR)
  }

  getComercial(): Rol {
  const rolName = this.tipoUsuarioARol['Comercial'];
    return this.getRol(rolName);
  }

  getECommerce(): Rol {
    return this.getRol(Roles.ECOMMERCE);
  }

  getUser(): User {
    if (this._local.getLocal('user')) {
      return this._local.getLocal('user')
    } else {
      // @ts-ignore
      return null
    }
  }
  getStore(): Store {
    // @ts-ignore
    this.store = null;
    if (this._local.getLocal('user')) {
      if (this._local.getLocal('user')['storeId']) {
        this.store = new Store
        this.store.storeId = this._local.getLocal('user')['storeId']
        this.store.name = this._local.getLocal('user')['storeName']
      }
    }
    // @ts-ignore
    return this.store
  }
  setStore(store: Store) {
    if (this._local.getLocal('user')) {
      let user = this._local.getLocal('user')
      user['storeId'] = store.storeId
      user['storeName'] = store.name
      this._local.setLocal('user', user)
    }
  }
  removeStore(): boolean {
    if (this._local.getLocal('user') && !this._local.getLocal('user')['subsidiaryId']) {
      let user = this._local.getLocal('user')
      user['storeId'] = null
      user['storeName'] = null
      this._local.setLocal('user', user)
      return true
    }else return false
  }

  getSubsidiary(): Subsidiary {
    // @ts-ignore
    this.subsidiary = null;
    if (this._local.getLocal('user')) {
      if (this._local.getLocal('user')['subsidiaryId']) {
        this.subsidiary = new Subsidiary
        this.subsidiary.storeSubsidiaryId = this._local.getLocal('user')['subsidiaryId']
        this.subsidiary.label = this._local.getLocal('user')['subsidiaryName']
      }
    }
    // @ts-ignore
    return this.subsidiary
  }
  setSubsidiary(subsidiary: Subsidiary) {
    if (this._local.getLocal('user')) {
      let user = this._local.getLocal('user')
      user['subsidiaryId'] = subsidiary.storeSubsidiaryId
      user['subsidiaryName'] = subsidiary.label
      this._local.setLocal('user', user)
    }
  }

  removeSubsidiary() {
    if (this._local.getLocal('user')) {
      let user = this._local.getLocal('user')
      this.exitSubsidiary.emit(true)
      // @ts-ignore
      this.subsidiary = null
      user['subsidiaryId'] = null
      user['subsidiaryName'] = null
      this._local.setLocal('user', user)
    }
  }

}
